import { render, staticRenderFns } from "./AvatarPeople.vue?vue&type=template&id=9d717708&scoped=true"
import script from "./AvatarPeople.vue?vue&type=script&lang=js"
export * from "./AvatarPeople.vue?vue&type=script&lang=js"
import style0 from "./AvatarPeople.vue?vue&type=style&index=0&id=9d717708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d717708",
  null
  
)

export default component.exports